export default {"src":"/_next/static/media/peep-hero-user.5b942804.svg","height":2600,"width":2600};